/**
 * V2 Mega Menu 交互逻辑
 * 创建日期：2025-08-18
 * 版本：v2.3
 * 说明：超级菜单交互逻辑，包含背景蒙层功能
 */

document.addEventListener('DOMContentLoaded', function() {
  
  // 创建背景蒙层
  let backdrop = document.querySelector('.v2-mega-menu-backdrop');
  if (!backdrop) {
    backdrop = document.createElement('div');
    backdrop.className = 'v2-mega-menu-backdrop';
    
    // 检测是否为覆盖模式（index页面）
    const isOverlayMode = document.querySelector('.header-wrapper.v2-header-overlay--desktop-only');
    
    // 根据页面模式设置不同的z-index
    // 覆盖模式：z-index: 1000（在菜单1001下方）
    // 非覆盖模式：z-index: 99（在内容1-10上方，在header group 100-101下方）
    backdrop.style.cssText = `
      position: fixed !important;
      top: 0 !important;
      left: 0 !important;
      width: 100vw !important;
      height: 100vh !important;
      background-color: rgba(0, 0, 0, 0.4) !important;
      backdrop-filter: blur(2px) !important;
      -webkit-backdrop-filter: blur(2px) !important;
      z-index: ${isOverlayMode ? '1000' : '99'} !important;
      opacity: 0 !important;
      visibility: hidden !important;
      transition: opacity 0.3s ease, visibility 0.3s ease !important;
      pointer-events: none !important;
      display: block !important;
    `;
    
    // 插入到body的第一个位置
    if (document.body.firstChild) {
      document.body.insertBefore(backdrop, document.body.firstChild);
    } else {
      document.body.appendChild(backdrop);
    }
    
    // 点击蒙层关闭所有菜单
    backdrop.addEventListener('click', function() {
      closeAllMegaMenus();
    });
  }
  
  // 获取所有增强型超级菜单
  const megaMenus = document.querySelectorAll('.v2-enhanced-mega-menu');
  
  // 关闭所有超级菜单的函数
  function closeAllMegaMenus() {
    // 隐藏蒙层
    if (backdrop) {
      backdrop.classList.remove('active');
      backdrop.style.opacity = '0';
      backdrop.style.visibility = 'hidden';
      backdrop.style.pointerEvents = 'none';
    }
    
    // 查找所有打开的菜单
    const openMenus = document.querySelectorAll('.v2-mega-menu-wrapper[open], .mega-menu[open]');
    openMenus.forEach(details => {
      if (details.classList.contains('v2-mega-menu-wrapper')) {
        closeMegaMenuWithAnimation(details);
      } else {
        // 普通菜单直接关闭
        details.removeAttribute('open');
        const summary = details.querySelector('summary');
        if (summary) {
          summary.setAttribute('aria-expanded', 'false');
        }
      }
    });
    
    // 移除header的menu-open类
    const header = document.querySelector('.header');
    if (header && header.classList.contains('menu-open')) {
      header.classList.remove('menu-open');
    }
  }
  
  // 关闭单个菜单（带动画）
  function closeMegaMenuWithAnimation(details) {
    const content = details.querySelector('.v2-enhanced-mega-menu');
    const inner = content ? content.querySelector('.v2-mega-menu__inner') : null;
    
    if (content && !content.classList.contains('v2-menu-closing')) {
      // 重置内部动画
      const categories = content.querySelectorAll('.v2-mega-menu__category-item');
      categories.forEach(item => {
        item.classList.remove('v2-animate-slide-right');
      });
      
      const products = content.querySelectorAll('.v2-mega-menu__product-item');
      products.forEach(item => {
        item.classList.remove('v2-animate-slide-up');
      });
      
      const featured = content.querySelector('.v2-mega-menu__featured');
      if (featured) {
        featured.classList.remove('v2-animate-fade-in');
      }
      
      // 触发收起动画
      void content.offsetHeight; // 强制重排
      content.classList.add('v2-menu-closing');
      
      // 动画结束后关闭菜单
      setTimeout(() => {
        details.removeAttribute('open');
        content.classList.remove('v2-menu-closing');
        if (inner) {
          inner.classList.remove('v2-content-visible');
        }
        
        // 更新aria属性
        const summary = details.querySelector('summary');
        if (summary) {
          summary.setAttribute('aria-expanded', 'false');
        }
        
        // 检查是否还有其他菜单打开
        updateBackdropVisibility();
      }, 300); // 与CSS动画时长匹配
    }
  }
  
  // 更新蒙层可见性
  function updateBackdropVisibility() {
    const stillOpenMenus = document.querySelectorAll('.v2-mega-menu-wrapper[open], .mega-menu[open]');
    if (stillOpenMenus.length === 0 && backdrop) {
      backdrop.classList.remove('active');
      backdrop.style.opacity = '0';
      backdrop.style.visibility = 'hidden';
      backdrop.style.pointerEvents = 'none';
    }
  }
  
  // 显示蒙层
  function showBackdrop() {
    if (backdrop) {
      backdrop.classList.add('active');
      backdrop.style.opacity = '1';
      backdrop.style.visibility = 'visible';
      backdrop.style.pointerEvents = 'auto';
    }
  }
  
  // 监听菜单打开/关闭事件
  const observeMegaMenus = () => {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes' && mutation.attributeName === 'open') {
          const details = mutation.target;
          if (details.classList.contains('v2-mega-menu-wrapper') || details.classList.contains('mega-menu')) {
            if (details.hasAttribute('open')) {
              showBackdrop();
            } else {
              setTimeout(updateBackdropVisibility, 50);
            }
          }
        }
      });
    });
    
    // 观察所有菜单元素
    const menuElements = document.querySelectorAll('.v2-mega-menu-wrapper, .mega-menu');
    menuElements.forEach(details => {
      observer.observe(details, {
        attributes: true,
        attributeFilter: ['open']
      });
      
      // 如果菜单已经打开，立即显示蒙层
      if (details.hasAttribute('open')) {
        showBackdrop();
      }
    });
  };
  
  // 初始化观察器
  observeMegaMenus();
  
  // 延迟再初始化一次（处理动态加载的菜单）
  setTimeout(observeMegaMenus, 1000);
  
  // 滚轮事件关闭菜单
  let scrollTimeout;
  const handleScroll = function(e) {
    // 检查滚动事件是否来自菜单内部
    const isScrollInMenu = e.target.closest && e.target.closest('.v2-mega-menu');
    if (isScrollInMenu) return;
    
    clearTimeout(scrollTimeout);
    scrollTimeout = setTimeout(() => {
      closeAllMegaMenus();
    }, 50);
  };
  
  window.addEventListener('wheel', handleScroll, { passive: true });
  window.addEventListener('touchmove', handleScroll, { passive: true });
  
  // ESC键关闭菜单
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      closeAllMegaMenus();
    }
  });
  
  // 产品分类切换功能
  megaMenus.forEach(menu => {
    const categoryLinks = menu.querySelectorAll('.v2-mega-menu__category-link[data-collection]');
    const productsContainer = menu.querySelector('.v2-mega-menu__products-container');
    const viewAllLink = menu.querySelector('[data-view-all-link]');
    
    if (!categoryLinks.length || !productsContainer) return;
    
    const allProductGrids = productsContainer.querySelectorAll('.v2-mega-menu__products-grid');
    
    // 为每个分类链接添加点击事件
    categoryLinks.forEach(link => {
      link.addEventListener('click', function(e) {
        // 如果按住Ctrl或Cmd键，正常导航
        if (e.ctrlKey || e.metaKey) return;
        
        e.preventDefault();
        
        // 更新激活状态
        categoryLinks.forEach(l => l.classList.remove('active'));
        this.classList.add('active');
        
        // 获取集合句柄
        const collectionHandle = this.dataset.collection;
        
        // 隐藏所有产品网格
        allProductGrids.forEach(grid => {
          grid.style.display = 'none';
        });
        
        // 显示对应的产品网格
        const targetGrid = productsContainer.querySelector(`[data-collection-handle="${collectionHandle}"]`);
        if (targetGrid) {
          targetGrid.style.display = '';
          
          // 更新查看全部链接
          const collectionTitle = targetGrid.dataset.collectionTitle;
          if (viewAllLink) {
            viewAllLink.href = `/collections/${collectionHandle}`;
            viewAllLink.innerHTML = `View All ${collectionTitle} <span class="v2-mega-menu__arrow-icon">${viewAllLink.querySelector('.v2-mega-menu__arrow-icon').innerHTML}</span>`;
          }
          
          // 应用动画
          applyProductAnimations(targetGrid);
        }
      });
    });
  });
  
  // 应用产品动画
  function applyProductAnimations(container) {
    const items = container.querySelectorAll('.v2-mega-menu__product-item');
    
    // 先移除所有动画类
    items.forEach(item => {
      item.classList.remove('v2-animate-slide-up');
    });
    
    // 强制重排
    void container.offsetHeight;
    
    // 延迟添加动画类
    items.forEach((item, index) => {
      setTimeout(() => {
        item.classList.add('v2-animate-slide-up');
      }, index * 100);
    });
    
    // 确保父容器有正确的类
    const megaMenu = container.closest('.v2-enhanced-mega-menu');
    if (megaMenu && !megaMenu.classList.contains('v2-content-visible')) {
      megaMenu.classList.add('v2-content-visible');
    }
  }
});